import React from 'react';
import LockIcon from '@material-ui/icons/Lock';
import {connect} from 'react-redux';
import {preventDefaultDrag} from '../../Utils/utils';

class NoBuildingAccess extends React.Component {
    render() {
        const {isLargeScreen} = this.props;
        return (
            <div onDragStart={preventDefaultDrag} className={`no-building-access ${!isLargeScreen ? 'mobile' : ''}`}>
                <LockIcon fontSize={'inherit'} />
                <span>Your package doesn't have access to this Building.</span>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLargeScreen: state.layout.isLargeScreen,
    };
};

export default connect(mapStateToProps)(NoBuildingAccess);
